import { render, staticRenderFns } from "./HubDetails.vue?vue&type=template&id=52162d26&"
import script from "./HubDetails.vue?vue&type=script&lang=js&"
export * from "./HubDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports